import { render, staticRenderFns } from "./operation-board-duty-log.vue?vue&type=template&id=39b9ef4a&scoped=true&"
import script from "./operation-board-duty-log.vue?vue&type=script&lang=js&"
export * from "./operation-board-duty-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9ef4a",
  null
  
)

export default component.exports